<script setup lang="ts">
import { mergeProps, useAttrs } from "vue";

/** The standard "remove this row" control: a red trash icon. [label] is the tooltip and
 * accessible name. */
defineOptions({ inheritAttrs: false });
defineProps<{ label: string }>();
const attrs = useAttrs();
</script>

<template>
  <v-tooltip :text="label" location="top">
    <template #activator="{ props: tooltipProps }">
      <v-btn
        v-bind="mergeProps(attrs, tooltipProps)"
        color="error"
        variant="text"
        density="comfortable"
        icon="mdi-delete"
        :aria-label="label"
      />
    </template>
  </v-tooltip>
</template>
